import { useState, useCallback } from 'react';

export interface UsePopoverReturn {
  /** The anchor element for the popover, or null if closed */
  anchorEl: HTMLElement | null;
  /** Whether the popover is currently open */
  isOpen: boolean;
  /** Click handler to open the popover - pass to the trigger button's onClick */
  open: (event: React.MouseEvent<HTMLElement>) => void;
  /** Close handler for the popover - pass to the Popover's onClose */
  close: () => void;
}

/**
 * Manages popover state (anchor element and open/close handlers).
 */
export function usePopover(): UsePopoverReturn {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    anchorEl,
    isOpen: Boolean(anchorEl),
    open,
    close,
  };
}
